import React from 'react';
import { TextField, MenuItem } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { updateAssetIdentification } from '../../../../state';
import { useGetAssetCategoriesQuery } from '../../../../../../services/DimensionService/dimensionApi';

const AssetCategoryEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentAsset } = useAppSelector(state => state.asset);
  const { data: categories = [] } = useGetAssetCategoriesQuery();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateAssetIdentification({ category: event.target.value }));
  };

  return (
    <TextField
      label="Category"
      size="small"
      required
      select
      fullWidth
      value={currentAsset?.category || ''}
      onChange={handleChange}
    >
      <MenuItem value="">
        <em>Select Category</em>
      </MenuItem>
      {categories.map((cat) => (
        <MenuItem key={cat.value} value={cat.value}>
          {cat.name}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default AssetCategoryEdit;
